import React from 'react';
import { Inbox } from 'lucide-react';
import FeedbackBriefkastenPanel from '../components/FeedbackBriefkastenPanel';

/**
 * Der Feedback-Briefkasten als eigene Seite.
 *
 * Warum nicht an der Instanz: Rücklaufpakete kommen aus ALLEN Installationen,
 * und die Frage lautet „was ist hereingekommen", nicht „was hat diese eine
 * Instanz geschickt". Der Weg zur Instanz führt trotzdem von hier — jede Zeile
 * verlinkt sie.
 */
export default function FeedbackBriefkastenPage() {
  return (
    <>
      <div className="mb-4">
        <h1 className="flex items-center gap-2 text-xl font-semibold text-slate-900">
          <Inbox size={20} /> Feedback-Briefkasten
        </h1>
        <p className="text-sm text-slate-500">
          Rücklaufpakete aus den Abnahmen der Kundeninstallationen
        </p>
      </div>
      <FeedbackBriefkastenPanel />
    </>
  );
}
